import React from 'react';
import clsx from 'clsx';
import { HashLink as Link } from 'react-router-hash-link';
import Grid from '@material-ui/core/Grid';
import Button from '../../../../components/Button';

import illustration from '../../../../assets/svgs/hero_bizz.svg';

const component = ({ classes }) => {
  const learnLink = React.forwardRef((props, ref) => (
    // eslint-disable-next-line
    <Link {...props} smooth to='#fitur' ref={ref} />
  ));

  return (
    <Grid
      alignItems='center'
      className={classes.root}
      spacing={3}
      container
      justify='center'
    >
      <Grid
        item
        md={6}
        xs={12}
        className={classes.mobileOrder1}
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <img
          alt=''
          className={clsx(classes.fullWidth, classes.imgFuncDisabled)}
          src={illustration}
        />
      </Grid>
      <Grid item md={6} xs={12} className={classes.mobileOrder2}>
        <Grid container alignItems='center'>
          <Grid item xs={12} md={11}>
            <h3 style={{ color: '#848585' }}>NGAMENBIZZ</h3>
            <h1 className={classes.header1}>
              Temukan musisi terbaik untuk bisnis dan acaramu!
            </h1>
          </Grid>
          <Grid item xs={12} md={8} className={classes.spacingBottom}>
            <p>
              <span style={{ fontWeight: 'bold' }}>Ngamen Bizz</span> adalah
              platform yang menghubungkan event organizer, pemilik studio musik,
              penyewa dan penjual alat musik dengan para musisi.
            </p>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item>
                <Button
                  component={learnLink}
                  type='outlined'
                  prop={{
                    style: { width: '220px' },
                  }}
                >
                  pelajari lebih lanjut
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default component;
